import React from "react";
import { XIcon } from "@heroicons/react/solid";
import FriendList from "./FriendList";
import axios from "axios";
import backendService from "../services.js/backendService";

import { ToastContainer, toast } from "react-toastify";
import toastProp from "../global/toastProps";

function CreateGroupModal({ showModal }) {
  const [selectedMembers, setSelectedMembers] = React.useState([]);
  const [groupName, setGroupName] = React.useState("");

  const getFriendList = (data) => {
    setSelectedMembers(data);
    
  };

  const getIDS = () => {
    let ids = [];
    selectedMembers.map((el) => {
      ids.push(el._id);
    });
    return ids;
  };

  const createGroup = async () => {
    const id = toast.loading("Please wait ...", { theme: "light" });
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/creategroup`,
        {
          groupName: groupName,
          participants: getIDS(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      toast.update(id, toastProp("Group created successfully", true));
      
    } catch (error) {
      console.log(error);
      toast.update(id, toastProp("Error creating group", false));
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none   ">
        <div className="w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3 relative my-6 mx-auto max-w-lg rounded-lg shadow-md shadow-black">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start bg-background justify-between p-5  rounded-t">
              <h3 className="text-3xl font-robo text-primary ">Create Group</h3>
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => showModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="relative px-5 flex-auto bg-background">
              <form action="#" method="POST">
                <div className="col-span-6 sm:col-span-3">
                  <div className="w-[100%]">
                    <label className="block text-md pb-1 font-robo text-primary ">
                      Group name
                      <span className="text-red"> *</span>
                    </label>
                    <input
                      type="text"
                      name="groupName"
                      id="groupName"
                      autoComplete="off"
                      className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                      placeholder="Enter group name"
                      onChange={(e) => setGroupName(e.target.value)}
                      required
                    />
                    <div className="flex items-center">
                      <label className="block text-md font-robo text-primary ">
                        Select members
                        <span className="text-red"> *</span>
                      </label>
                      <h4 className="text-sm  text-secondary font-robo ">
                        (Select at least 2 members)
                      </h4>
                    </div>
                    <FriendList friendList={getFriendList} />
                  </div>
                </div>
              </form>
            </div>
            {/*footer*/}
            <div className="flex items-center bg-background justify-end p-3  rounded-b">
              <button
                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                onClick={() => {
                  if (selectedMembers.length < 2) {
                    toast.error("Select at least 2 members", { theme: "light" });
                  } else {
                    createGroup();
                    showModal(false);
                  }
                }}
              >
                Create Group
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="opacity-50  fixed inset-0 z-40 bg-black"></div> */}
    </>
  );
}

export default CreateGroupModal;
